import AccountTypePage from './AccountTypePage';
export default AccountTypePage;
